var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternetBanking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1082_1871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 12.5C29 10.0277 28.2669 7.61099 26.8934 5.55538C25.5199 3.49976 23.5676 1.89761 21.2835 0.951511C18.9995 0.00541607 16.4861 -0.242126 14.0614 0.24019C11.6366 0.722505 9.40933 1.91301 7.66117 3.66117C5.91301 5.40933 4.7225 7.63661 4.24019 10.0614C3.75787 12.4861 4.00542 14.9995 4.95151 17.2835C5.89761 19.5676 7.49976 21.5199 9.55538 22.8934C11.611 24.2669 14.0277 25 16.5 25C19.8141 24.9963 22.9913 23.6781 25.3347 21.3347C27.6781 18.9913 28.9963 15.8141 29 12.5ZM17.5417 22.5199V13.5417H20.6444C20.538 16.0598 20.047 18.3837 19.2345 20.1712C18.7396 21.2617 18.1464 22.072 17.5417 22.5199ZM17.5417 11.4583V2.48008C18.1464 2.928 18.7389 3.73829 19.2344 4.82878C20.0469 6.61628 20.5379 8.94024 20.6443 11.4583H17.5417ZM15.4583 2.48008V11.4583H12.3556C12.462 8.94024 12.953 6.61628 13.7655 4.82878C14.2611 3.73829 14.8537 2.928 15.4583 2.48008ZM15.4583 13.5417V22.5199C14.8537 22.072 14.2611 21.2617 13.7656 20.1712C12.953 18.3837 12.462 16.0598 12.3556 13.5417H15.4583ZM20.5921 22.0781C20.7895 21.7393 20.9694 21.3905 21.1311 21.0332C22.0612 18.9871 22.6177 16.3581 22.7284 13.5417H26.8646C26.6755 15.3947 25.9942 17.1634 24.8913 18.6644C23.7883 20.1654 22.304 21.3441 20.5921 22.0781ZM26.8646 11.4583H22.7284C22.6177 8.64193 22.0612 6.01289 21.1311 3.9668C20.9694 3.60951 20.7895 3.26075 20.5921 2.92188C22.304 3.65595 23.7883 4.83459 24.8913 6.33559C25.9942 7.8366 26.6755 9.60531 26.8646 11.4583ZM12.4079 2.92188C12.2105 3.26075 12.0306 3.60951 11.8689 3.9668C10.9388 6.01289 10.3823 8.64193 10.2716 11.4583H6.13542C6.3245 9.60531 7.00582 7.8366 8.10875 6.33559C9.21168 4.83459 10.696 3.65595 12.4079 2.92188ZM6.13542 13.5417H10.2716C10.3823 16.3581 10.9388 18.9871 11.8689 21.0332C12.0306 21.3905 12.2105 21.7393 12.4079 22.0781C10.696 21.3441 9.21168 20.1654 8.10875 18.6644C7.00582 17.1634 6.3245 15.3947 6.13542 13.5417Z",
    fill: "#B4B4B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1082_1871",
    x: 0,
    y: 0,
    width: 33,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1082_1871"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1082_1871",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetBanking);
export default __webpack_public_path__ + "static/media/internet-banking.e458137b6e93a2026ad6e588607189e9.svg";
export { ForwardRef as ReactComponent };